import React from "react";
import { View, StyleSheet } from "react-native";

import tinycolor from "tinycolor2";
import { colors } from "assets/constants";

const CheckboxIcon: React.FC<CheckBoxIconT> = ({
  size = 20,
  color = colors.theme,
  status = 0,
}) => {
  return (
    <View
      style={{
        ...styles.box,
        width: size,
        height: size,
        borderRadius: size / 3,
        borderColor:
          status === 0 ? "#bbb" : tinycolor(color).lighten(35).toString(),
        backgroundColor: tinycolor(color)
          .lighten(status === 0 ? 100 : 50)
          .toString(),
      }}
    >
      {status !== 0 && (
        <View
          style={{
            ...styles.fill,
            borderRadius: size / 3 - 2,
            backgroundColor: color,
            height: status === 1 ? "100%" : size / 5,
          }}
        />
      )}
    </View>
  );
};

export default CheckboxIcon;

const styles = StyleSheet.create({
  box: {
    padding: 2,
    alignItems: "center",
    justifyContent: "center",
    borderWidth: 1,
  },
  fill: { width: "100%" },
});
